import dayjs from "dayjs";

export const HHMM2min = (hhmm: string): number => {
  let res = 0;
  const arr = hhmm.match(/\d+/gi);
  if (!arr) return 0;
  const hour = arr[0];
  const min = arr[1];
  res = Number(hour) * 60;
  if (Number(min)) {
    res = res + Number(min);
  }
  return res;
};

export const addDigits = (str: number): string => {
    if (str < 0) {
        str = str * (-1)
    }
    if(str >= 10) {
        return String(str)
    } else {
        return `0${str}`
    }
}

export const min2HHMM = (min: number): string => {
  const hours = Math.floor(min / 60);
  const minutes = Math.floor(min % 60);
  return `${addDigits(hours)}:${addDigits(minutes)}`;
};

export   const validateTime = (datetime: string | null | undefined) => {
  const date = dayjs(datetime);
  if(date.isValid()) {
    return date.format("YYYY-MM-DD HH:mm")
  }
  return undefined;
}
